export enum KeyboardEventKey {
  Escape = "Escape",
}
